import { createFeatureSelector, createSelector } from '@ngrx/store';

import { StockPackingHistoryState } from './stock-packing-history.reducers';

export const stockPackingHistoryKey = 'stockPackingHistory';
export const selectStockPackingHistoryState = createFeatureSelector<StockPackingHistoryState>(stockPackingHistoryKey);

export const selectAllStockPackingHistoryList = createSelector(
  selectStockPackingHistoryState,
  (state: StockPackingHistoryState) => {
    return state?.selected;
  }
);

export const selectStockPackingHistoryListCriteria = createSelector(selectStockPackingHistoryState, (state) => {
  return state?.criteriaObject;
});

export const selectStockPackingHistoryTotalElements = createSelector(selectStockPackingHistoryState, (state) => {
  return state?.totalElements;
});
